<div id="ziro-admin-page-content" class="ziro-admin-page-content">
  <div data-automation="site-management" class="col-md-10 offset-md-1 h-100">
    <router-outlet></router-outlet>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
